<template>
  <component :is="component" />
</template>

<script>
import Statistics from './Statistics';

export default Statistics;
</script>

<style lang="scss" scoped>
@import 'Statistics';
</style>
